import { Model } from '@vuex-orm/core'
import config from '@/utils/config'
import type { Request } from '@vuex-orm/plugin-axios'

export default class Profile extends Model {
  declare id: string
  declare available_balance: Record<string, number>
  declare balance: Record<string, number>
  declare city?: string
  declare countrycode?: string
  declare dateofbirth?: string
  declare email?: string
  declare firstname?: string
  declare gender?: number
  declare blacklisted: boolean
  declare correspondencelanguage?: string
  declare lastname?: string
  declare phone?: string
  declare addressId: number
  declare street?: string
  declare zipcode?: string
  declare hasRekaNetAccount: boolean

  static entity = 'profile'

  static fields() {
    return {
      id: this.uid(),
      available_balance: this.attr(0),
      balance: this.attr(0),
      city: this.string(null).nullable(),
      countrycode: this.string(null).nullable(),
      dateofbirth: this.string(null).nullable(),
      email: this.string(null).nullable(),
      firstname: this.string(null).nullable(),
      gender: this.number(null),
      blacklisted: this.boolean(false),
      correspondencelanguage: this.string(null).nullable(),
      lastname: this.string(null).nullable(),
      phone: this.string(null).nullable(),
      addressId: this.number(0),
      street: this.string(null).nullable(),
      zipcode: this.string(null).nullable(),
      hasRekaNetAccount: this.boolean(false)
    }
  }

  static isLoggedIn() {
    return !!this.query().count()
  }

  static getRekaCardSaldo() {
    const profile =  this.query().first()

    if (profile) {
      return profile.balance
    }
  }

  static apiConfig = {
    actions: {
      async getProfile(this: Request) {
        try {
          return await this.get(`${config.bookingApi}/CustomerPortal/Profile`, {
            persistBy: 'create'
          })
        } catch (e) {
          /* Emulate profile in development */
          if (process.env.VUE_APP_EMULATE_PROFILE) {
            console.warn(
              '[Profile] Using emulated Reka account data. '+
              'Please, make sure you only use this feature during development'
            )

            return Profile.insertOrUpdate({
              data: {
                available_balance: {
                  pay: 484520
                },
                balance: {
                  pay: 484520
                },
                city: 'Bern',
                countrycode: 'CH',
                dateofbirth: '1982-08-22T00:00:00',
                email: 'jonas@busy-rooms.com',
                firstname: "Marco",
                gender: 0,
                blacklisted: false,
                correspondencelanguage: "de_ch",
                lastname: 'Wölfli',
                phone:'+41444444444',
                addressId: 2759121,
                street: 'Neuengasse 15',
                zipcode: '300100',
                hasRekaNetAccount: true
              }
            })
          }
        }
      }
    }
  }
}
